<template>
  <div
    id="side-page"
    class="d-flex fs-unmask"
  >
    <div id="side-page-container">
      <div
        id="side-page-rg-logo-container"
      >
        <div>
          <img
            src="@/assets/images/tango-logo-surface.svg"
            alt="Tango"
          >
        </div>
        <div>
          {{ $t('portalfrontendApp.sidePage.logoSubText') }}
        </div>
      </div>
      <did-you-know-cta />
    </div>
  </div>
</template>

<script>
import DidYouKnowCta from './DidYouKnowCta'

export default {
  name: 'SidePage',
  components: {
    DidYouKnowCta
  }
}
</script>

<style scoped lang="scss">
  @import '~@/assets/scss/global';
  #side-page {
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    margin-left: -15px;
    width: 40%;
    min-width: 500px;
    float: left;
    box-shadow: inset 0 0 20px 6px rgba(0,0,0,.25);

    #side-page-notch {
      position: relative;
      left: 2px;

      &.side-page-notch-mobile {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
      }
    }

    #side-page-container {
      display: flex;
      flex-direction: column;
      max-width: 100%;
      width: 100%;
      background-image: url("data:image/svg+xml,%3Csvg width='56' height='96' viewBox='0 0 56 96' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='56' height='96' fill='%234A4296'/%3E%3Cpath d='M28 0C14.744 0 4 10.744 4 24C4 37.256 14.744 48 28 48C41.256 48 52 37.256 52 24C52 10.744 41.256 0 28 0ZM28 36.296C18.904 36.296 13.1707 27.432 16.7653 18.56C20.064 20.04 23.8533 20.8453 28 20.8453C32.1467 20.8453 35.936 20.04 39.2347 18.56C42.8293 27.4293 37.096 36.296 28 36.296Z' fill='white' fill-opacity='0.02'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 68.8453V48C13.256 48 24 58.744 24 72C24 85.256 13.256 96 0 96V84.296C9.096 84.296 14.8293 75.4293 11.2347 66.56C7.936 68.04 4.14667 68.8453 0 68.8453Z' fill='white' fill-opacity='0.02'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M56 68.8453V48C42.744 48 32 58.744 32 72C32 85.256 42.744 96 56 96V84.296C46.904 84.296 41.1707 75.4293 44.7653 66.56C48.064 68.04 51.8533 68.8453 56 68.8453Z' fill='white' fill-opacity='0.02'/%3E%3C/svg%3E%0A");
      background-color: var(--t-color-primary);
      background-repeat: repeat;
      position: relative;

      .side-page-lower-container {
        display: flex;
        width: 100%;
        height: 100%;
      }

    }

    #side-page-rg-logo-container {
      margin-top: 3.75rem;
      img {
        width: 163px;
        height: 37px;
      }
      color: var(--t-color-text-inverted);
      font-size: var(--t-font-size-0);          //14px
      line-height: var(--t-font-lineheight-6);  // 36px
      font-weight: var(--t-font-weight-4);      // 400
      padding-inline: 5rem;
    }
  }

  @media (max-width: $breakpoint-lg - 1) {
    #side-page {
      width: 100%;
      height: 16rem;
      margin: 0;
      display: none !important;

      &.did-you-know-background {
        background-position: right top;
        background-size: cover !important;
      }

      #side-page-container {

        .side-page-text {
          width: 100%;

          &#side-page-quote {
            top: unset;
            left: unset;

            #side-page-quote-text {
              font-size: 1rem;
              line-height: 1.125rem;
            }
          }
        }
      }
    }
  }
  .t-svg-color > g {
    fill: var(--t-color-surface);
  }
  @media (min-width: $breakpoint-lg) and (max-width: $breakpoint-xl - 1) {
    #side-page {

      #side-page-container {
        #side-page-open-quotation-mark {
          left: -50%;
          transform: scale(.5);
        }

        #side-page-close-quotation-mark {
          right: -22%;
          transform: scale(.5);
        }

        .side-page-text {
          width: 200px;

          &#side-page-quote {
            left: 0;
          }

        }
      }
    }
  }

  @media (min-width: $breakpoint-xl) and (max-width: $breakpoint-xxl - 1) {
    #side-page {
      #side-page-container {

        #side-page-open-quotation-mark {
          left: -30%;
          transform: scale(.75);
        }

        #side-page-close-quotation-mark {
          transform: scale(.75);
        }

        .side-page-text {
          width: 250px;

          &#side-page-quote {
            left: 0;
          }

          &#side-page-dyk {

            #side-page-dyk-header {
              font-size: 1.25rem;
              line-height: 1.5rem;
            }

            #side-page-dyk-tidbit {
              font-size: 1rem;
              line-height: 1.5rem;
            }

            #side-page-dyk-learn-more-button {
              margin-top: .875rem;
              font-size: .75rem;
            }
          }
        }
      }
    }
  }
</style>
